
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Ce vaccin serait cher (même si, en Suisse, la vaccination est offerte par la
Confédération!). En fait, les contrats sont confidentiels et les tarifs ne sont
pas fournis. Mais en décembre 2020, la ministre belge du budget a publié sur
Twitter des `}<a parentName="p" {...{
        "href": "762891513855"
      }}>{`montants négociés à l'époque par l’Union européenne`}</a>{`.
Ces chiffres, qu’elle a dû rapidement supprimer, permettent de se faire une
idée: quelque 18 dollars pour le vaccin de Moderna (le prix le plus élevé de
tous ceux présentés alors), contre 1,78 euros pour celui d’AstraZeneca.`}</p>
    <p>{`L’emploi d’une nouvelle technologie, passant par la génétique, crée une certaine
`}<a parentName="p" {...{
        "href": "404485565357"
      }}>{`appréhension`}</a>{` dans la population. Les experts répondent que l’ARN
messager n’entre pas dans le noyau de nos cellules (où notre matériel génétique
est stocké), le code qui leur est envoyé disparaît en 48 heures de notre corps
et ce vaccin est donc sûr.`}</p>
    <p>{`La fréquence d'effets secondaires désagréables mais peu dangereux (du style état
grippal), en particulier après l'injection de la deuxième dose, a surpris
certains experts. Ce point faible, toutefois, est paradoxalement un bon signe:
il signifie que le système immunitaire réagit. Il faut préciser que ce principe
vaut à un niveau "global" et non individuel: il serait faux de penser que le
vaccin n'a pas fonctionné si une personne n'a pas réagi.`}</p>
    <p>{`Cet automne 2021, le risque de myocardite suite à la vaccination a conduit
quelques pays à suspendre son utilisation pour les jeunes (lire notre rubrique
sur les effets secondaires). En Suisse, ce danger est relativisé, car il est six
fois moins élevé que celui de myocardite suite au Covid.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;